import { render, staticRenderFns } from "./CollectionContent.vue?vue&type=template&id=dd20f6ac&scoped=true"
import script from "./CollectionContent.vue?vue&type=script&lang=js"
export * from "./CollectionContent.vue?vue&type=script&lang=js"
import style0 from "./CollectionContent.vue?vue&type=style&index=0&id=dd20f6ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd20f6ac",
  null
  
)

export default component.exports